import React, { useState, useEffect } from 'react';
import { TextField } from '@mui/material';
import {
  formatNumberAsCurrencyMask,
  handleCurrencyInputChange,
} from '../../../app/currency';
import { useTranslation } from '../../../app/LanguageContext';

const selectOnFocus = (event) => {
  event.target.select?.();
};

const toNumeric = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const parsed = typeof value === 'number' ? value : parseFloat(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export default function CurrencyTextField({
  value,
  onChange,
  label,
  size = 'medium',
  fullWidth = false,
  disabled = false,
  allowEmpty = false,
  helperText,
  placeholder,
  sx,
  inputRef,
  onBlur: onBlurProp,
  onFocus: onFocusProp,
  ...rest
}) {
  const { language } = useTranslation();
  const [focused, setFocused] = useState(false);
  const [text, setText] = useState('');

  const numeric = toNumeric(value);
  const showEmpty = allowEmpty && (numeric === null || numeric === 0) && !focused;

  const shown = focused
    ? text
    : showEmpty
      ? ''
      : formatNumberAsCurrencyMask(numeric ?? 0);

  useEffect(() => {
    if (!focused) setText('');
  }, [language, value, focused]);

  const emitValue = (next) => {
    if (next === null || next === undefined || next === '') {
      onChange?.(0);
      return;
    }
    onChange?.(Number.isFinite(next) ? next : 0);
  };

  return (
    <TextField
      {...rest}
      size={size}
      fullWidth={fullWidth}
      label={label}
      value={shown}
      disabled={disabled}
      helperText={helperText}
      placeholder={placeholder}
      inputRef={inputRef}
      onFocus={(event) => {
        setFocused(true);
        if (showEmpty || numeric === null) {
          setText('');
        } else {
          setText(formatNumberAsCurrencyMask(numeric));
        }
        selectOnFocus(event);
        onFocusProp?.(event);
      }}
      onBlur={(event) => {
        setFocused(false);
        setText('');
        onBlurProp?.(event);
      }}
      onChange={(event) => {
        handleCurrencyInputChange(event, (synth) => {
          if (typeof synth === 'string') {
            setText('');
            emitValue(allowEmpty ? 0 : 0);
            return;
          }
          setText(synth.target.value);
          const next = synth.target.numericValue;
          emitValue(typeof next === 'number' && Number.isFinite(next) ? next : 0);
        });
      }}
      sx={sx}
      inputProps={{
        inputMode: 'decimal',
        ...rest.inputProps,
      }}
    />
  );
}
